import React, { Fragment } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { gql } from '@apollo/client'
import { Ward } from '@website2018/sc-component'
import { Helmet } from "react-helmet-async";
import { decode } from 'he';
import {
  Aside,
  Border,
  Copy,
  CardContact,
  ButtonTest,
  Heading,
  HeadingLines,
  Hero,
  Icon,
  Loading,
  SectionFull,
  Sidebar,
  variables
} from '@website2018/da-dobsonville'
import { StyleSheet, css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import Asides from '../../components/Asides/Asides'
import FormContainer from '../../containers/Data/FormContainer'
import FormBuilderContainer from '../../containers/Data/FormBuilderContainer'
import { checkLink } from '../../common/utils'

class ContactTemplate extends React.Component {
  state = {
    selected: null
  }

  getOption(option) {
    if (option.type === 'form') {
      const {
        site: { options }
      } = this.props

      return (
        <div>
          <Heading level={6} mt="small" mb="small" color={'blue'}>
            {option.title}
          </Heading>
          <FormContainer
            formId={option.form_id}
            render={form => (
              <FormBuilderContainer
                admin_email={options.email}
                initValues={{
                  structure_code: options.structureCode,
                  structure_type: options.structure
                }}
                inputClass="col-md-12"
                form={form}
              />
            )}
          />
        </div>
      )
    }

    return (
      <div>
        <Heading level={6} mt="small" mb="small" color={'blue'}>
          {option.title}
        </Heading>
        <Copy>{option.content}</Copy>
        {option.button_link && checkLink(option.button_link) ? (
          <Link to={option.button_link}>
            <ButtonTest color="green" center>
              {option.button_label}
            </ButtonTest>
          </Link>
        ) : (
          <a href={option.button_link} target="_blank" rel="noopener noreferrer">
            <ButtonTest color="green" center>
              {option.button_label}
            </ButtonTest>
          </a>
        )}
      </div>
    )
  }

  render() {
    const { fonts, fontWeight, fontStyles, letterSpacing, spacing } = variables
    const { error, loading, page: p, site } = this.props

    if (loading) return <Loading />
    if (error || !p) return <Redirect to={'/not-found'} />

    const {
      meta: {
        contact: { heading, options = [] }
      }
    } = p

    let selected = this.state.selected || options[0]

    const styles = {
      table: {
        fontFamily: fonts.sans,
        marginBottom: spacing.space1,
        ...fontStyles('12px', '14px')
      },
      td: {
        paddingRight: spacing.space2,
        paddingBottom: spacing.space05
      },
      tdLabel: {
        letterSpacing: letterSpacing.small,
        fontWeight: fontWeight.medium,
        paddingRight: spacing.space2,
        paddingTop: spacing.space05,
        paddingBottom: spacing.space05,
        verticalAlign: 'top'
      }
    }

    const baseStyles = StyleSheet.create({
      table: {
        ...styles.table
      },
      td: {
        ...styles.td
      },
      tdLabel: {
        ...styles.tdLabel
      }
    })

    return [
      <Helmet
        defaultTitle={decode(p.seo.title !== '' ? p.seo.title : p.title.rendered)}
        meta={[
          {
            name: 'description',
            content: p.seo.metadesc !== '' ? p.seo.metadesc : p.excerpt.rendered
          },
          {
            name: 'og:title',
            content: p.seo['opengraph-title'] !== '' ? p.seo['opengraph-title'] : p.title.rendered
          },
          {
            name: 'og:description',
            content:
              p.seo['opengraph-description'] !== ''
                ? p.seo['opengraph-description']
                : p.excerpt.rendered
          },
          { name: 'og:url', content: `` },
          { name: 'og:site_name', content: `Democratic Alliance` },
          { name: 'og:type', content: `business` },
          { name: 'og:image', content: p.seo['opengraph-image'] || null },
          { name: 'fb:app_id', content: '1262049647255981' },
          { name: 'twitter:card', content: '”summary_large_image”' },
          { name: 'twitter:site', content: '@our_da' },
          {
            name: 'twitter:title',
            content: p.seo['twitter-title'] !== '' ? p.seo['twitter-title'] : p.title.rendered
          },
          {
            name: 'twitter:description',
            content:
              p.seo['twitter-description'] !== ''
                ? p.seo['twitter-description”']
                : p.excerpt.rendered
          },
          {
            name: 'twitter:image',
            content: p.seo['twitter-image'] !== '' ? p.seo['twitter-image'] : null
          }
        ]}
        htmlAttributes={{ lang: 'en' }}
      />,
      <Hero
        imageUrl={null}
        title={p.hero && p.hero.headline ? p.hero.headline : p.title.rendered}
        bgPosition={null}
      />,
      <Fragment>
        {p.content.rendered && (
          <SectionFull>
            <div className={'col-lg-8'}>
              <Copy intro html={p.content.rendered} />
            </div>
          </SectionFull>
        )}
      </Fragment>,
      <SectionFull pt="none" pb="none" mb={'small'}>
        <div className="col-md-12">
          <div className="row row-eq-height">
            {p.contact_details.regions &&
              p.contact_details.regions
                .filter(r => r.region_name === site.province.title.rendered)
                .map(r => (
                  <Fragment>
                    {r.department &&
                      r.department.map(d => (
                        <div className="col">
                          <CardContact title={d.title}>
                            <table className={css(baseStyles.table)}>
                              {d.contact_details &&
                                d.contact_details.map(c => (
                                  <tr>
                                    {c.label && (
                                      <td className={css(baseStyles.tdLabel)}>
                                        <Icon fs="16px" name={c.label} />
                                      </td>
                                    )}
                                    {c.detail && (
                                      <td className={css(baseStyles.td)}>
                                        {c.link === 'no' ? (
                                          <Copy mb="none" html={c.detail} />
                                        ) : null}
                                        {c.link === 'phone' ? (
                                          <a
                                            href={`tel:${c.detail}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Copy mb="none" html={c.detail} />
                                          </a>
                                        ) : null}
                                        {c.link === 'email' ? (
                                          <a
                                            href={`mailto:${c.detail}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Copy mb="none" html={c.detail} />
                                          </a>
                                        ) : null}
                                        {c.link === 'url' ? (
                                          <a
                                            href={`http://${c.detail}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Copy mb="none" html={c.detail} />
                                          </a>
                                        ) : null}
                                      </td>
                                    )}
                                  </tr>
                                ))}
                            </table>
                          </CardContact>
                        </div>
                      ))}
                  </Fragment>
                ))}
          </div>
        </div>
      </SectionFull>,
      <div id="ward">
        <Ward
          title={site.options.wardTitle}
          description={site.options.wardDescription}
          apiKey={process.env.RAZZLE_GOOGLE_MAPS_API_KEY}
        />
      </div>,
      <SectionFull pt={'large'}>
        <div className={'col-md-7'}>
          <HeadingLines lineLeft color={'red'} mb={'large'}>
            <Heading color={'red'} tracking={'huge'} size={'tiny'} weight={'light'} uppercase>
              {'Contact Us'}
            </Heading>
          </HeadingLines>
          <Aside title={heading} vertical>
            <div className="form-group">
              <select
                className="form-control"
                onChange={e =>
                  this.setState({
                    selected: e.target.value ? options[e.target.value] : null
                  })
                }
              >
                {options.map((o, index) => (
                  <option value={index} key={`options-help-${index}`}>
                    {o.title}
                  </option>
                ))}
              </select>
            </div>
            {selected && <Border />}
            {selected ? this.getOption(selected) : null}
          </Aside>
        </div>
        <Sidebar className={'col-md-4 ml-auto'}>{p.asides && <Asides asides={p.asides} />}</Sidebar>
      </SectionFull>
    ]
  }
}

const TEMPLATE_QUERY = gql`
  query getTemplate {
    page(slug: "contact") {
      id
      slug
      seo
      template
      title {
        rendered
      }
      content {
        rendered
      }
      excerpt {
        rendered
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
      }
      hero {
        headline
        cta_type
        cta_group {
          title
          link_label
          link_url
        }
        background_image {
          url
        }
        focus_point
      }
      asides {
        id
        title {
          rendered
        }
        content {
          rendered
        }
        aside_options
      }
      meta {
        contact {
          heading
          options {
            button_link
            button_label
            form_id
            content
            title
            type
          }
        }
      }
      contact_details {
        offices {
          title
          contact_information {
            label
            detail
            link
          }
        }
        regions {
          region_name
          department {
            title
            contact_details {
              label
              detail
              link
            }
          }
        }
      }
    }
  }
`

const withTemplate = graphql(TEMPLATE_QUERY, {
  props: ({ data, post }) => ({ ...data })
})

export default withTemplate(ContactTemplate)
